import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'components.Capture.placeholder',
    defaultMessage: 'Please enter the captcha code',
    description: 'placeholder',
  },
})
